module.exports = __webpack_public_path__ + "static/img/yytx10.313511a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx10.png
// module id = 790
// module chunks = 0